import currency from "currency.js";
import { RoundtripFlightSummary } from "./use-available-flight-packages";
import { useTripsWithOffers } from "./use-trips-with-offers";

export const useFlightPrices = () => {
    const tripsWithOffers = useTripsWithOffers();
    const getTrip = (tripId?: string) =>
        tripsWithOffers.find((trip) =>
            tripId ? trip._id === tripId : trip.isPrimary,
        );
    const getFlightOffer = (flightLineItemCode: string, tripId?: string) => {
        const trip = getTrip(tripId);
        const departingFlightOffer = trip?.departingFlightOffers.find(
            (offer) => offer.flight.lineItemCode === flightLineItemCode,
        );
        const returningFlightOffer = trip?.returningFlightOffers.find(
            (offer) => offer.flight.lineItemCode === flightLineItemCode,
        );
        return departingFlightOffer || returningFlightOffer;
    };

    const getRoundtripSalePrice = (
        roundtrip?: RoundtripFlightSummary,
        tripId?: string,
    ) => {
        if (!roundtrip) {
            return 0;
        }
        const trip = getTrip(tripId);
        const baseDepartingPrice = currency(
            roundtrip.departingFlight.discountAmount?.value ?? 0,
        ).add(roundtrip.departingFlight.salePrice?.value ?? 0).value;

        const baseReturningPrice = currency(
            roundtrip.returningFlight.discountAmount?.value ?? 0,
        ).add(roundtrip.returningFlight.salePrice?.value ?? 0).value;
        const departingOfferPrice =
            getFlightOffer(
                roundtrip.departingFlight.flight.lineItemCode,
                trip?._id,
            )?.salePrice?.value ?? baseDepartingPrice;
        const returningOfferPrice =
            getFlightOffer(
                roundtrip.returningFlight.flight.lineItemCode,
                trip?._id,
            )?.salePrice?.value ?? baseReturningPrice;
        return currency(departingOfferPrice).add(returningOfferPrice).value;
    };
    return {
        getRoundtripSalePrice,
    };
};
